export function parseCopyRuleResponse(responseData: any): { success: any[]; failure: any[] } {
    const success: any[] = [];
    const failure: any[] = [];
    const rules = Array.isArray(responseData) ? responseData : [responseData];

    rules.forEach((rule) => {
        if (!rule) {
            return;
        }
        const ruleId = rule.ruleId != null ? rule.ruleId : (rule.RuleId != null ? rule.RuleId : rule.RuleID);
        const mrpcResponses = Array.isArray(rule.mrpCs) ? rule.mrpCs : [];
        mrpcResponses.forEach((value: any) => {
            const messageText = value && value.messageText ? value.messageText : '';
            const messageParts = messageText.split('>');
            if (messageText.includes('Copy rule failed for')) {
                const failureReasonParts = (messageParts[1] || '').split('due to ');
                value.msgSplit1 = 'Rule ID ' + ruleId + ' - ' + (messageParts[0] || '');
                value.msgSplit2 = failureReasonParts[0] || '';
                value.msgSplit3 = failureReasonParts[1] || '';
                failure.push(value);
            } else if (messageText.includes('Copied Successfully to')) {
                value.msgSplit1 = 'Rule ID ' + ruleId + ' - ' + (messageParts[0] || '');
                value.msgSplit2 = messageParts[1] || '';
                success.push(value);
            }
        });
    });

    return { success, failure };
}
